// Detection ancre dans l'URL au chargement de la page
$(document).ready(function() {
    // Si l'URL contient un hash (#id) on tente de trouver l'élément par sont id sur la page
    if( window.location.hash ){
        var $target = $(window.location.hash);
        if( $target !== undefined && $target.length ){
            // Si l'élément est trouvé on scroll vers l'élément au bout de 1000ms pour compléter
            // le déplacement natif du scroll au chargement de la page
            setTimeout(scrollToTarget, 1000, $target);
        }
    }
});

/**
 * Au clique sur un lien avec la classe scroll, on va faire un scroll adapté en temps vers l'élément
 * sur la page s'il est trouvé
 */
$('body').on('click', 'a.scroll', function (evt) {
    evt.preventDefault();

    let $link = $(this);

    if($link.hasClass('nav-link')){
        // Si on est dans la modale de menu mobile, on ferme le menu mobile
        var $modal = $link.parents('.modal');
        if( $modal !== undefined && $modal.length ){
            $modal.modal('hide');
        }
    }

    // On tronque la partie URL (avant le dièse s'il y en a comme ici : /brisach#pourquoi
    let url = $link.attr('href');
    if( url.indexOf("#") >= 0 ){
        var target = url.substring(url.indexOf("#"));
        var $target = $(target);
    }

    // Si la cible (id) existe sur la page on scroll vers elle sinon on execute un changement de page normal
    if( $target !== undefined && $target.length ){
        scrollToTarget($target);
    } else {
        window.location.href = url;
    }

});

$('body').on('click', 'a.page-link', function (evt) {
    evt.preventDefault();

    let $link = $(this);

    if($link.hasClass('nav-link')){
        // Si on est dans la modale de menu mobile, on ferme le menu mobile
        var $modal = $link.parents('.modal');
        if( $modal !== undefined && $modal.length ){
            $modal.modal('hide');
        }
    }

    // On tronque la partie URL (avant le dièse s'il y en a comme ici : /brisach#pourquoi
    let url = $link.attr('href');
    if( url.indexOf("#") >= 0 ){
        var target = url.substring(url.indexOf("#"));
        var $target = $(target);
    }

    // Si la cible (id) existe sur la page on scroll vers elle sinon on execute un changement de page normal
    if( $target !== undefined && $target.length ){
        scrollToTarget($target);
    } else {
        window.scrollTo(0, 0);
        if(!$('body').hasClass("category")){
            window.location.href = url;
        }
    }

});

function scrollToTarget($target, height){
    // Hauteur de l'entête à retirer de la hauteur à scroller (140px par défaut)
    height = typeof height !== "undefined" ? height : 140;

    let $headerDefault = $("#header");
    if ($headerDefault !== undefined && $headerDefault.length) {
        height = $headerDefault[0].offsetHeight+20;
    }
    let $headerBrisach = $("#header-brisach");
    if ($headerBrisach !== undefined && $headerBrisach.length) {
        height = $headerBrisach[0].offsetHeight+20;
    }

    // Dynamisation du délai de scroll pour qu'il soit proportionnel à la taille à scroller.
    // Il faudra peut être revenir dessus.
    // Ca a été fait et testé pour la page /faq où l'on avait des effets de latence car 1000ms
    // c'était trop long pour scroller un petit contenu 700px à 1000px
    const sizeToScrollTo = $target.offset().top - height;
    const delayToScrollTo = sizeToScrollTo*0.1;

    $('html, body').stop().animate({scrollTop: sizeToScrollTo}, delayToScrollTo);
}
